enum ExcelExportParameter {
  SUBSTRATES = "substrateSamples",
  TESA_PRODUCTS = "tesaProducts",
  TEST_METHODS = "testMethods",
}

export default ExcelExportParameter;
